import type { AxiosResponse } from "axios";
import { isAxiosError } from "axios";

import type { ApiResponse, ErrorResponse, ErrorResult } from "~/api/apiResponseTypes.ts";
import { ApiResponseErrorType } from "~/api/apiResponseTypes.ts";

export const getDataFromResponse = <T>(res: AxiosResponse<ApiResponse<T>>): T => res.data.data;

export function handleApiError(error: unknown): ErrorResult {
	if (isAxiosError(error)) {
		const errorCode = error.response?.status || 0;

		if (errorCode === 422) {
			const validationErrors: ErrorResponse = error.response?.data ?? { errors: {} };

			return {
				type: ApiResponseErrorType.VALIDATION,
				code: errorCode,
				messages: validationErrors.errors,
			};
		} else {
			return {
				type: ApiResponseErrorType.AXIOS,
				code: errorCode,
				message: error.message,
			};
		}
	} else {
		return {
			type: ApiResponseErrorType.UNKNOWN,
			message: String(error),
		};
	}
}
